import { colors } from "../../styles/style";

const styleSectionDelivery = {
  container: {
    marginTop: 20,
    width: "100%",
    border: "dashed",
    padding: "4%",
    borderColor: colors.GRAY_5_COLOR,
    backgroundColor: colors.WHITE_COLOR,
    borderRadius: 15,
    alignContent: "center",
    alignItems: "center",
  },
  normalContainer: {
    marginTop: 20,
    width: "100%",
    border: "none",
    padding: "2%",
    backgroundColor: colors.WHITE_COLOR,
    alignContent: "center",
    alignItems: "center",
  },
  containerButton: {
    display: "flex",
    justifyContent: "center",
  },
  containerSelected: {
    marginTop: 20,
    marginLeft: 1,
    width: "100%",
    border: "dashed",
    padding: "1.5%",
    borderColor: colors.GRAY_5_COLOR,
    backgroundColor: colors.WHITE_COLOR,
    borderRadius: 15,
    alignContent: "center",
    alignItems: "center",
  },
  textOptionSelected: {
    color: colors.GRAY_4_COLOR,
    marginTop: 15,
  },
  alignButtonOptDroped: {
    alignItems: "center",
    alignContent: "end",
    flexDirection: "row",
    display: "flex",
    backgroundColor: "#34ff"
  },
};

export { styleSectionDelivery };
